import * as React from "react";
import { styled, Skeleton, Box } from "@mui/material";

const PushContentSlideSkeleton: React.FC = () => {
  return (
    <Wrapper>
      <Skeleton width={700} height={40} />
      <Skeleton width={300} height={40} />
    </Wrapper>
  );
};

export default PushContentSlideSkeleton;

const Wrapper = styled(Box)(({ theme }) => ({
  height: 468,
  width: "100%",
  borderRadius: 12,
  backgroundColor: theme.palette.background[300],
  padding: theme.spacing(3),
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "column",
}));
